import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type JobApplicationEvents =
  | 'DELETE_FROM_TABLE'
  | 'DELETE_FROM_DETAILS'
  | 'ACTION_SELECTION'
  | 'JOB_APPLICATION_HUB_CLICK_JOB_APPLICATION_TITLE'
  | 'JOB_APPLICATION_HUB_CLICK_JOB_APPLICATION_ID'
  | 'JOB_APPLICATION_HUB_CLICK_JOB_APPLICATION_JOB_APPLICATIONING_PARTY'
  | 'JOB_APPLICATION_HUB_CLICK_JOB_APPLICATION_REQUESTOR'
  | 'JOB_APPLICATION_TOOLBAR_ADD_JOB_APPLICATION'
  | 'JOB_APPLICATION_HUB_START_SEARCH_BAR'
  | 'JOB_APPLICATION_SELECT_NEW_ADD_JOB_APPLICATION_BUTTON'
  | 'JOB_APPLICATION_CLICK_EXPORT_DROPDOWN_BUTTON'
  | 'JOB_APPLICATION_CLICK_EXPORT_EXCEL_BUTTON'
  | 'JOB_APPLICATION_CLICK_EXPORT_CSV_BUTTON'
  | 'JOB_APPLICATION_CLICK_IMPORT_BUTTON'
  | 'JOB_APPLICATION_FILTER_BUTTON'
  | 'JOB_APPLICATION_FILTER_STATUS'
  | 'JOB_APPLICATION_FILTER_TYPE'
  | 'JOB_APPLICATION_DETAILS_DETAILS_TAB'
  | 'JOB_APPLICATION_DETAILS_TABS_CLICK'
  | 'JOB_APPLICATION_DETAILS_PROCESSES_TAB'
  | 'JOB_APPLICATION_CLICK_PROCESS_ENTITY_DESCRIPTOR'
  | 'JOB_APPLICATION_HUB_CLICK_DELETE_JOB_APPLICATION_OVERFLOW_ACTION'
  | 'JOB_APPLICATION_HUB_CLICK_EDIT_PROCESS_OVERFLOW_ACTION'
  | 'JOB_APPLICATION_HUB_CLICK_CHANGE_HISTORY_OVERFLOW_ACTION'
  | 'EXPORT_JOB_APPLICATION_RESULT';

export const jobApplication: Record<JobApplicationEvents, MixpanelEvent> = {
  DELETE_FROM_TABLE: {
    eventDescription: 'Delete JobApplication (Table)',
    eventKey: 'job-application-delete-table',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  DELETE_FROM_DETAILS: {
    eventDescription: 'Delete JobApplication (Details)',
    eventKey: 'job-application-delete-details',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  ACTION_SELECTION: {
    eventKey: 'job-application-hub-action_selection',
    eventDescription: 'User selected action from the overflow menu',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  JOB_APPLICATION_HUB_CLICK_JOB_APPLICATION_TITLE: {
    eventKey: 'job-application-hub-click-job-application-title',
    eventDescription: 'User clicks work request title in work request hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  JOB_APPLICATION_HUB_CLICK_JOB_APPLICATION_ID: {
    eventKey: 'job-application-hub-click-job-application-id',
    eventDescription: 'User clicks work request id in work request hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  JOB_APPLICATION_HUB_CLICK_JOB_APPLICATION_JOB_APPLICATIONING_PARTY: {
    eventKey: 'job-application-hub-click-job-application-job-applicationing-party',
    eventDescription: 'User clicks work request parent work requesting party in work request hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  JOB_APPLICATION_HUB_CLICK_JOB_APPLICATION_REQUESTOR: {
    eventKey: 'job-application-hub-click-job-application-requestor',
    eventDescription: 'User clicks work request requestor in work request hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  JOB_APPLICATION_TOOLBAR_ADD_JOB_APPLICATION: {
    eventKey: 'job-application-hub-toolbar-add-job-application',
    eventDescription: 'User clicks add work request from work request hub toolbar',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.APP_TOOLBAR_BUTTON
  },
  JOB_APPLICATION_HUB_START_SEARCH_BAR: {
    eventKey: 'job-application-hub-click-search-bar-and-starts-search',
    eventDescription: 'User clicks search bar in work requests hub and starts search',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SEARCH_INPUT
  },
  JOB_APPLICATION_SELECT_NEW_ADD_JOB_APPLICATION_BUTTON: {
    eventKey: 'job-application-click-add-new-job-application-select',
    eventDescription: 'User clicks select button to add new work request and start page flow',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_CLICK_EXPORT_DROPDOWN_BUTTON: {
    eventKey: 'job-application-click-export-dropdown-button',
    eventDescription: 'User clicks export to dropdown button in work requests hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_CLICK_EXPORT_EXCEL_BUTTON: {
    eventKey: 'job-application-click-export-excel-button',
    eventDescription: 'User clicks export to excel button in work requests hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_CLICK_EXPORT_CSV_BUTTON: {
    eventKey: 'job-application-click-export-csv-button',
    eventDescription: 'User clicks export to csv button in work requests hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_CLICK_IMPORT_BUTTON: {
    eventKey: 'job-application-click-import-button',
    eventDescription: 'User clicks import button in work requests hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_FILTER_BUTTON: {
    eventKey: 'job-application-click-toolbar-filter-button',
    eventDescription: 'User clicks toolbar filter button in work requests hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_FILTER_STATUS: {
    eventKey: 'job-application-click-filter-status-select',
    eventDescription: 'User clicks work request filter status input',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_FILTER_TYPE: {
    eventKey: 'job-application-click-filter-type-select',
    eventDescription: 'User clicks work request filter type option',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_DETAILS_DETAILS_TAB: {
    eventKey: 'job-application-details-page-view-details',
    eventDescription: 'User views work request details tab in work request details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_DETAILS_TABS_CLICK: {
    eventKey: 'job-application-details-tabs-click',
    eventDescription: 'contract details tabs click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SUB_MENU_BUTTON
  },
  JOB_APPLICATION_DETAILS_PROCESSES_TAB: {
    eventKey: 'job-application-details-page-view-processes',
    eventDescription: 'User views work request processes tab in work request details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_CLICK_PROCESS_ENTITY_DESCRIPTOR: {
    eventKey: 'job-application-details-page-processes-user-click-entity-descriptor',
    eventDescription: 'User clicks entity descriptor in processes tab in work request details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_HUB_CLICK_DELETE_JOB_APPLICATION_OVERFLOW_ACTION: {
    eventKey: 'job-application-hub-user-click-delete-job-application',
    eventDescription: 'User clicks delete work request overflow action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_HUB_CLICK_EDIT_PROCESS_OVERFLOW_ACTION: {
    eventKey: 'job-application-hub-user-click-edit-job-application',
    eventDescription: 'User clicks edit work request overflow action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  JOB_APPLICATION_HUB_CLICK_CHANGE_HISTORY_OVERFLOW_ACTION: {
    eventKey: 'job-application-hub-user-click-view-job-application-change-history',
    eventDescription: 'User clicks view work request change history overflow action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  EXPORT_JOB_APPLICATION_RESULT: {
    eventKey: 'click-job-application-quick-report-export',
    eventDescription: 'User clicks work request quick report export',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  }
} as const;
